import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import { DraftData, draftDataSchema } from '../../api/Drafts';

const storageKey = (id: string) => `local-draft-${id}`;

const decodeDraftData = (s: string) => {
  const result = draftDataSchema.safeParse(s);
  console.log('Result', result);
  if (result.success) {
    return O.some(result.data);
  } else {
    return O.none;
  }
};

export const saveLocalDraft = (id: string, draft: DraftData) => {
  let json = JSON.stringify(draft);
  localStorage.setItem(storageKey(id), json);
};

export const tryLoadLocalDraft = (id: string): DraftData | undefined =>
  pipe(
    O.fromNullable(localStorage.getItem(storageKey(id))),
    O.map(JSON.parse),
    O.chain(decodeDraftData),
    O.toUndefined
  );

export const clearLocalDraft = (id: string) => {
  localStorage.removeItem(storageKey(id));
};
